// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2_2Dk","footer":"ModalInfo_footer__1Pb6v"};